import Vue from 'vue'

Vue.component('VueMarked', () => import('vue-marked'))
Vue.component('lock-button', () => import('./LockButton.vue'))
Vue.component('loading', () => import('./loading.vue'))
Vue.component('ui-modal', () => import('./ui-modal.vue'))
Vue.component('ui-loading', () => import('./loading.vue'))
Vue.component('ui-dotlottie-loader', () => import('./ui-dotlottie-loader.vue'))